import { render, staticRenderFns } from "./DosyaRaporTipiInfo.vue?vue&type=template&id=544b8901"
import script from "./DosyaRaporTipiInfo.vue?vue&type=script&lang=ts"
export * from "./DosyaRaporTipiInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports